import { RQParam, RQHandlers, RQService, RQApp } from '../RQuery/RQuery';
import { dmHotel }                               from '../pages/sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../services/MLText';

export class dmMenuItem {
    Parent:        dmMenuGroup;

    Index:         number;
    IsNearbyEntry: boolean;
    Hidden:        boolean;
    IsHref:        boolean;
    Selected:      boolean;
    Label:         string;

    Navigator:     () => void;
    Icon:          string;
    IconClass:     string;
    GetURI:        () => void;

    constructor(
         pParent:        dmMenuGroup
        ,pIsNearbyEntry: boolean
        ,pLabel:         string
        ,pNavigator:     () => void
        ,pIcon:          string
        ,pIconClass:     string
        ,pGetURI?:       () => any
    ) {
        this.Parent        = pParent;
        this.IsNearbyEntry = pIsNearbyEntry;
        this.Index         = 0;
        this.Hidden        = false;
        this.IsHref        = false;
        this.Selected      = false;
        this.Label         = pLabel;
        this.Navigator     = pNavigator;
        this.Icon          = pIcon;
        this.IconClass     = pIconClass;

        if (pGetURI) {
            this.IsHref = true;
            this.GetURI = pGetURI;
        }
    }

    public SetIndex(pIndex: number): void {
        this.Index = pIndex;
    }

    public Select(): void {
        for (let i: number = 0; i < this.Parent.Parent.Items.length; i++) {
            let group: dmMenuGroup = this.Parent.Parent.Items[i];

            for (let j: number = 0; j < group.Items.length; j++) {
                let item: dmMenuItem = group.Items[j];

                item.Selected = false;
            }
        }

        this.Selected = true;

        this.Navigator();
    }

    public GetItemURI(): any {
        return this.GetURI();
    }
}

export class dmMenuGroup {
    Parent:        dmMenu;

    Index:         number;
    IsNearbyEntry: boolean;
    Hidden:        boolean;
    Expanded:      boolean;
    Label:         string;

    Items:         dmMenuItem[];

    constructor(
         pParent:        dmMenu
        ,pLabel:         string
        ,pIsNearbyEntry: boolean
    ) {
        this.Parent        = pParent;
        this.IsNearbyEntry = pIsNearbyEntry;
        this.Index         = 0;
        this.Hidden        = false;
        this.Expanded      = false;
        this.Label         = pLabel;

        this.Items         = [];
    }

    public SetIndex(pIndex: number): void {
        this.Index = pIndex;
    }

    public AddItem(pMenuItem: dmMenuItem): void {
        pMenuItem.SetIndex(this.Items.length);

        this.Items.push(pMenuItem);
    }

    public Expand(): void {
        for (let i: number = 0; i < this.Parent.Items.length; i++) {
            let group: dmMenuGroup = this.Parent.Items[i];

            if (group.Index != this.Index) {
                group.Expanded = false;
            }
        }

        this.Expanded = true;
    }

    public Collapse(): void {
        this.Expanded = false;
    }

    public ToggleGroup(): void {
        if (this.Expanded) { this.Collapse(); }
        else               { this.Expand();   }
    }
}

export class dmMenuSlot {
    IsGroupEntry: boolean;
    GroupEntry:   dmMenuGroup;
    ItemEntry:    dmMenuItem;

    constructor(
         pIsGroupEntry: boolean
        ,pGroupEntry:   dmMenuGroup
        ,pItemEntry:    dmMenuItem
    ) {
        this.IsGroupEntry = pIsGroupEntry;
        this.GroupEntry   = pGroupEntry;
        this.ItemEntry    = pItemEntry;
    }
}

export class dmMenu {
    Items: dmMenuGroup[];
    Slots: dmMenuSlot[];

    constructor() {
        this.Items = [];
        this.Slots = [];
    }

    private navToIndex(
         pGroupIndex: number
        ,pItemIndex:  number
    ) {
        for (let i: number = 0; i < this.Items.length; i++) {
            let group = this.Items[i];

            if (group.Index == pGroupIndex) {
                group.Expanded = true;
            } else {
                group.Expanded = false;
            }

            for (let j: number = 0; j < group.Items.length; j++) {
                let item = group.Items[j];

                if (
                    group.Index == pGroupIndex
                &&  item.Index  == pItemIndex
                ) {
                    item.Selected = true;
                } else {
                    item.Selected = false;
                }
            }
        }
    }

    public AddGroup(pMenuGroup: dmMenuGroup): void {
        pMenuGroup.SetIndex(this.Items.length);

        this.Items.push(pMenuGroup);
    }

    public ConsolidateSlots(): void {
        for (let i: number = 0; i < this.Items.length; i++) {
            let group     = this.Items[i];
            let groupSlot = new dmMenuSlot(true, group, null);

            this.Slots.push(groupSlot);

            for (let j: number = 0; j < group.Items.length; j++) {
                let item     = group.Items[j];
                let itemSlot = new dmMenuSlot(false, null, item);

                this.Slots.push(itemSlot);
            }
        }
    }

    public Reset(): void {
        this.Items = [];
        this.Slots = [];
    }

    public SetNearbyDisplay(pNearbyOnly: boolean): void {
        for (let i: number = 0; i < this.Items.length; i++) {
            let group = this.Items[i];

            if (pNearbyOnly && (!group.IsNearbyEntry)) {
                group.Hidden = true;
            } else {
                group.Hidden = false;
            }

            for (let j: number = 0; j < group.Items.length; j++) {
                let item = group.Items[j];

                if (pNearbyOnly && (!item.IsNearbyEntry)) {
                    item.Hidden = true;
                } else {
                    item.Hidden = false;
                }
            }
        }
    }

    /* maintenance - careful of hardcoded menu indices here! */
    public NavToWelcome(): void {
        this.navToIndex(0 ,0);
    }

    public NavToEnable(): void {
        this.navToIndex(4 ,0);
    }

    public NavToSettings(): void {
        this.navToIndex(2 ,0);
    }

    public NavToPMS(): void {
        this.navToIndex(5 ,2);
    }

    public NavToHousekeeping(): void {
        this.navToIndex(2 ,0);
    }
}

export class AppMenuViewModel {
    BackToSignIn:       () => void;
    GoToWelcome:        () => void;
    GoToTemplate:       () => void;
    GoToHousekeeping:   () => void;
    GoToDetails:        () => void;
    GoToEnable:         () => void;
    GoToDiscounts:      () => void;
    GoToDiscountCal:    () => void;
    GoToRoomTypes:      () => void;
    GoToAvailability:   () => void;
    GoToOfferTypes:     () => void;
    GoToCustomPackages: () => void;
    GoToEarlyBird:      () => void;
    GoToChannel:        () => void;
    GoToRates:          () => void;
    GoToRooms:          () => void;
    GoToTaskList:       () => void;
    GoToTaskReport:     () => void;
    GoToStaff:          () => void;
    GoToDescriptions:   () => void;
    GoToPhotos:         () => void;
    GoToDocs:           () => void;
    GoToMaps:           () => void;
    GoToFacilities:     () => void;
    GoToCancellation:   () => void;
    GoToBookings:       () => void;
    GoToChangePassword: () => void;
    GoToPayment:        () => void;
    GoToSpotlight:      () => void;
    GoToPMS:            () => void;

    DoSignOut:          () => void;

    mlText:               MLText;
    app:                  mlBroker;
    ml:                   mlBroker;
    Hotel:                dmHotel;
    LangID:               number;

    Menu:                 dmMenu;

    AccountSettingsLabel: string;
    InventoryLabel:       string;
    HousekeepingLabel:    string;
    PricesLabel:          string;
    DiscountsLabel:       string;
    ServicesLabel:        string;
    PropertyInfoLabel:    string;

    HotelAreaLabel:       string;
    NotSignedInLabel:     string;
    SignedInAsLabel:      string;
    HotelIDLabel:         string;
    WelcomeLabel:         string;
    TemplateLabel:        string;
    CTMSignUpLabel:       string;
    CTMSettingsLabel:     string;
    EditDetailsLabel:     string;
    EnableRatesLabel:     string;
    MemberDiscountsLabel: string;
    DiscountCalLabel:     string;
    RoomTypesLabel:       string;
    AvailabilityLabel:    string;
    OfferTypesLabel:      string;
    CustomPackagesLabel:  string;
    EarlyBirdLabel:       string;
    ChannelLabel:         string;
    RatesLabel:           string;
    RoomsLabel:           string;
    TaskListLabel:        string;
    TaskReportLabel:      string;
    StaffLabel:           string;
    DescriptionsLabel:    string;
    PhotosLabel:          string;
    DocsLabel:            string;
    MapsLabel:            string;
    FacilitiesLabel:      string;
    CancellationLabel:    string;
    PoliciesLabel:        string;
    BookingsLabel:        string;
    ChangePasswordLabel:  string;
    PaymentLabel:         string;
    SpotlightLabel:       string;
    PMSLabel:             string;
    PreviewHPageLabel:    string;
    SignOutLabel:         string;

    HasException:         boolean;
    HasNetworkError:      boolean;

    constructor(
         pMLText:             MLText
        ,pHotel:              dmHotel
        ,pBackToSignIn:       () => void
        ,pGoToWelcome:        () => void
        ,pGoToTemplate:       () => void
        ,pGoToHousekeeping:   () => void
        ,pGoToDetails:        () => void
        ,pGoToEnable:         () => void
        ,pGoToDiscounts:      () => void
        ,pGoToDiscountCal:    () => void
        ,pGoToRoomTypes:      () => void
        ,pGoToAvailability:   () => void
        ,pGoToOfferTypes:     () => void
        ,pGoToCustomPackages: () => void
        ,pGoToEarlyBird:      () => void
        ,pGoToChannel:        () => void
        ,pGoToRates:          () => void
        ,pGoToRooms:          () => void
        ,pGoToTaskList:       () => void
        ,pGoToTaskReport:     () => void
        ,pGoToStaff:          () => void
        ,pGoToDescriptions:   () => void
        ,pGoToPhotos:         () => void
        ,pGoToDocs:           () => void
        ,pGoToMaps:           () => void
        ,pGoToFacilities:     () => void
        ,pGoToCancellation:   () => void
        ,pGoToBookings:       () => void
        ,pGoToChangePassword: () => void
        ,pGoToPayment:        () => void
        ,pGoToSpotlight:      () => void
        ,pGoToPMS:            () => void
    ) {
        this.mlText               = pMLText;
        this.LangID               = this.mlText.GetLangID();
        this.Hotel                = pHotel;
        this.BackToSignIn         = pBackToSignIn;
        this.GoToWelcome          = pGoToWelcome;
        this.GoToTemplate         = pGoToTemplate;
        this.GoToHousekeeping     = pGoToHousekeeping;
        this.GoToDetails          = pGoToDetails;
        this.GoToEnable           = pGoToEnable;
        this.GoToDiscounts        = pGoToDiscounts;
        this.GoToDiscountCal      = pGoToDiscountCal;
        this.GoToRoomTypes        = pGoToRoomTypes;
        this.GoToAvailability     = pGoToAvailability;
        this.GoToOfferTypes       = pGoToOfferTypes;
        this.GoToCustomPackages   = pGoToCustomPackages;
        this.GoToEarlyBird        = pGoToEarlyBird;
        this.GoToChannel          = pGoToChannel;
        this.GoToRates            = pGoToRates;
        this.GoToRooms            = pGoToRooms;
        this.GoToTaskList         = pGoToTaskList;
        this.GoToTaskReport       = pGoToTaskReport;
        this.GoToStaff            = pGoToStaff;
        this.GoToDescriptions     = pGoToDescriptions;
        this.GoToPhotos           = pGoToPhotos;
        this.GoToDocs             = pGoToDocs;
        this.GoToMaps             = pGoToMaps;
        this.GoToFacilities       = pGoToFacilities;
        this.GoToCancellation     = pGoToCancellation;
        this.GoToBookings         = pGoToBookings;
        this.GoToChangePassword   = pGoToChangePassword;
        this.GoToPayment          = pGoToPayment;
        this.GoToSpotlight        = pGoToSpotlight;
        this.GoToPMS              = pGoToPMS;

        this.Menu                 = new dmMenu();

        this.AccountSettingsLabel = '';
        this.InventoryLabel       = '';
        this.HousekeepingLabel    = '';
        this.PricesLabel          = '';
        this.DiscountsLabel       = '';
        this.ServicesLabel        = '';
        this.PropertyInfoLabel    = '';

        this.HotelAreaLabel       = '';
        this.NotSignedInLabel     = '';
        this.SignedInAsLabel      = '';
        this.CTMSignUpLabel       = '';
        this.CTMSettingsLabel     = '';
        this.WelcomeLabel         = '';
        this.TemplateLabel        = '';
        this.EditDetailsLabel     = '';
        this.EnableRatesLabel     = '';
        this.MemberDiscountsLabel = '';
        this.DiscountCalLabel     = '';
        this.RoomTypesLabel       = '';
        this.AvailabilityLabel    = '';
        this.OfferTypesLabel      = '';
        this.CustomPackagesLabel  = '';
        this.EarlyBirdLabel       = '';
        this.ChannelLabel         = '';
        this.RatesLabel           = '';
        this.RoomsLabel           = '';
        this.TaskListLabel        = '';
        this.TaskReportLabel      = '';
        this.StaffLabel           = '';
        this.DescriptionsLabel    = '';
        this.PhotosLabel          = '';
        this.DocsLabel            = '';
        this.MapsLabel            = '';
        this.FacilitiesLabel      = '';
        this.CancellationLabel    = '';
        this.PoliciesLabel        = '';
        this.BookingsLabel        = '';
        this.ChangePasswordLabel  = '';
        this.PaymentLabel         = '';
        this.SpotlightLabel       = '';
        this.PMSLabel             = '';
        this.PreviewHPageLabel    = '';
        this.SignOutLabel         = '';

        this.DoSignOut            = () => { this.SignOut(); };

        this.HasException         = false;
        this.HasNetworkError      = false;
    }

    public initialise() {
        this.app                = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml                 = this.mlText.GetBroker(
            'BookingEngineSignIn'
        );

        this.AccountSettingsLabel = this.ml.Text('AccountSettings'      ,'Account Settings');
        this.InventoryLabel       = this.ml.Text('RoomsAndInventory'    ,'Rooms And Inventory');
        this.HousekeepingLabel    = this.ml.Text('Housekeeping'         ,'Housekeeping');
        this.PricesLabel          = this.ml.Text('PricesAndPackages'    ,'Prices And Packages');
        this.DiscountsLabel       = this.ml.Text('Discounts'            ,'Discounts');
        this.ServicesLabel        = this.ml.Text('Services'             ,'Services');
        this.PropertyInfoLabel    = this.ml.Text('PropertyInfo'         ,'Property Info');

        this.HotelAreaLabel       = this.ml.Text('HotelArea'            ,'Hotel Area');
        this.NotSignedInLabel     = this.ml.Text('NotSignedIn'          ,'Not Signed In');
        this.SignedInAsLabel      = this.ml.Text('SignedInAs'           ,'Signed in as');
        this.HotelIDLabel         = this.ml.Text('HotelID'              ,'HotelID');
        this.WelcomeLabel         = this.ml.Text('Welcome'              ,'Welcome');
        this.TemplateLabel        = this.ml.Text('EngineTemplate'       ,'Engine Template');
        this.CTMSignUpLabel       = this.ml.Text('ActivateHousekeeping' ,'Activate Housekeeping');
        this.CTMSettingsLabel     = this.ml.Text('Settings'             ,'Settings');
        this.EditDetailsLabel     = this.ml.Text('EditDetails'          ,'Edit Details');
        this.EnableRatesLabel     = this.ml.Text('CompetitivePackages'  ,'Competitive Packages');
        this.MemberDiscountsLabel = this.ml.Text('MemberDiscounts'      ,'Member Discounts');
        this.DiscountCalLabel     = this.ml.Text('DiscountCalendar'     ,'Discount Calendar');
        this.RoomTypesLabel       = this.ml.Text('RoomTypes'            ,'Room Types');
        this.AvailabilityLabel    = this.ml.Text('Availability'         ,'Availability');
        this.OfferTypesLabel      = this.ml.Text('RatePackages'         ,'Rate Packages');
        this.CustomPackagesLabel  = this.ml.Text('CustomPackages'       ,'Custom Packages');
        this.EarlyBirdLabel       = this.ml.Text('EarlyBirdRate'        ,'Early Bird Rate');
        this.ChannelLabel         = this.ml.Text('ChannelProvider'      ,'Channel Provider');
        this.RatesLabel           = this.ml.Text('Rates'                ,'Rates');
        this.RoomsLabel           = this.ml.Text('RoomNumbers'          ,'Room Numbers');
        this.StaffLabel           = this.ml.Text('Staff'                ,'Staff');
        this.TaskListLabel        = this.ml.Text('TaskList'             ,'Task List');
        this.TaskReportLabel      = this.ml.Text('TaskHandlingReport'   ,'Task Handling Report');
        this.DescriptionsLabel    = this.ml.Text('Descriptions'         ,'Descriptions');
        this.PhotosLabel          = this.ml.Text('Photos'               ,'Photos');
        this.DocsLabel            = this.ml.Text('Brochures'            ,'Brochures');
        this.MapsLabel            = this.ml.Text('Maps'                 ,'Maps');
        this.FacilitiesLabel      = this.ml.Text('Facilities'           ,'Facilities');
        this.CancellationLabel    = this.ml.Text('Cancellation'         ,'Cancellation');
        this.PoliciesLabel        = this.ml.Text('Policies'             ,'Policies');
        this.BookingsLabel        = this.ml.Text('Bookings'             ,'Bookings');
        this.ChangePasswordLabel  = this.ml.Text('ChangePassword'       ,'Change Password');
        this.PaymentLabel         = this.ml.Text('Payment'              ,'Payment');
        this.SpotlightLabel       = this.ml.Text('SpotlightPrices'      ,'Spotlight Prices');
        this.PMSLabel             = this.ml.Text('DownloadORCAPMS'      ,'Download ORCA PMS');
        this.PreviewHPageLabel    = this.ml.Text('PreviewHotelPage'     ,'Preview Hotel Page');
        this.SignOutLabel         = this.ml.Text('SignOut'              ,'Sign Out');

        this.InitializeMenu();
    }

    public InitializeMenu(): void {
        this.Menu.Reset();

        let account      = new dmMenuGroup(this.Menu ,this.AccountSettingsLabel ,true);
        let rooms        = new dmMenuGroup(this.Menu ,this.InventoryLabel       ,false);
        let housekeeping = new dmMenuGroup(this.Menu ,this.HousekeepingLabel    ,true);
        let prices       = new dmMenuGroup(this.Menu ,this.PricesLabel          ,false);
        let discounts    = new dmMenuGroup(this.Menu ,this.DiscountsLabel       ,false);
        let services     = new dmMenuGroup(this.Menu ,this.ServicesLabel        ,true);
        let propertyInfo = new dmMenuGroup(this.Menu ,this.PropertyInfoLabel    ,false);

        this.Menu.AddGroup(account);
        this.Menu.AddGroup(rooms);
        this.Menu.AddGroup(housekeeping);
        this.Menu.AddGroup(prices);
        this.Menu.AddGroup(discounts);
        this.Menu.AddGroup(services);
        this.Menu.AddGroup(propertyInfo);

        account.AddItem(new dmMenuItem(
             account
            ,false
            ,this.WelcomeLabel
            ,this.GoToWelcome
            ,'alert'
            ,'tb-icon-primary'
        ));

        account.AddItem(new dmMenuItem(
             account
            ,true
            ,this.ChangePasswordLabel
            ,this.GoToChangePassword
            ,'key'
            ,'tb-icon-alert'
        ));

        account.AddItem(new dmMenuItem(
             account
            ,true
            ,this.EditDetailsLabel
            ,this.GoToDetails
            ,'create'
            ,'tb-icon-ok'
        ));

        if (this.Hotel.WithEngineTemplate) {
            account.AddItem(new dmMenuItem(
                 account
                ,false
                ,this.TemplateLabel
                ,this.GoToTemplate
                ,'build'
                ,'tb-icon-alert'
            ));
        }

        account.AddItem(new dmMenuItem(
             account
            ,false
            ,this.ChannelLabel
            ,this.GoToChannel
            ,'code-working'
            ,'tb-icon-warn'
        ));

        account.AddItem(new dmMenuItem(
             account
            ,true
            ,this.SignOutLabel
            ,this.DoSignOut
            ,'log-out'
            ,'tb-icon-primary'
        ));

        rooms.AddItem(new dmMenuItem(
             rooms
            ,false
            ,this.RoomTypesLabel
            ,this.GoToRoomTypes
            ,'home'
            ,'tb-icon-warn'
        ));

        rooms.AddItem(new dmMenuItem(
             rooms
            ,false
            ,this.AvailabilityLabel
            ,this.GoToAvailability
            ,'checkbox'
            ,'tb-icon-ok'
        ));

        if (this.Hotel.WithHousekeeping) {
            housekeeping.AddItem(new dmMenuItem(
                 housekeeping
                ,true
                ,this.CTMSettingsLabel
                ,this.GoToHousekeeping
                ,'settings'
                ,'tb-icon-primary'
            ));

            housekeeping.AddItem(new dmMenuItem(
                 housekeeping
                ,true
                ,this.RoomTypesLabel
                ,this.GoToRoomTypes
                ,'home'
                ,'tb-icon-warn'
            ));

            housekeeping.AddItem(new dmMenuItem(
                 housekeeping
                ,true
                ,this.RoomsLabel
                ,this.GoToRooms
                ,'home'
                ,'tb-icon-alert'
            ));
            
            housekeeping.AddItem(new dmMenuItem(
                 housekeeping
                ,true
                ,this.StaffLabel
                ,this.GoToStaff
                ,'person'
                ,'tb-icon-primary'
            ));
            
            housekeeping.AddItem(new dmMenuItem(
                 housekeeping
                ,true
                ,this.TaskListLabel
                ,this.GoToTaskList
                ,'list-box'
                ,'tb-icon-ok'
            ));
            
            housekeeping.AddItem(new dmMenuItem(
                 housekeeping
                ,true
                ,this.TaskReportLabel
                ,this.GoToTaskReport
                ,'alarm'
                ,'tb-icon-warn'
            ));
        } else {
            housekeeping.AddItem(new dmMenuItem(
                 housekeeping
                ,true
                ,this.CTMSignUpLabel
                ,this.GoToHousekeeping
                ,'alert'
                ,'tb-icon-primary'
            ));
        }

        prices.AddItem(new dmMenuItem(
             prices
            ,false
            ,this.OfferTypesLabel
            ,this.GoToOfferTypes
            ,'cube'
            ,'tb-icon-primary'
        ));

        prices.AddItem(new dmMenuItem(
             prices
            ,false
            ,this.CustomPackagesLabel
            ,this.GoToCustomPackages
            ,'cube'
            ,'tb-icon-alert'
        ));

        prices.AddItem(new dmMenuItem(
             prices
            ,false
            ,this.RatesLabel
            ,this.GoToRates
            ,'card'
            ,'tb-icon-ok'
        ));

        prices.AddItem(new dmMenuItem(
             prices
            ,false
            ,this.ChannelLabel
            ,this.GoToChannel
            ,'code-working'
            ,'tb-icon-warn'
        ));

        discounts.AddItem(new dmMenuItem(
             discounts
            ,false
            ,this.SpotlightLabel
            ,this.GoToSpotlight
            ,'ribbon'
            ,'tb-icon-warn'
        ));

        discounts.AddItem(new dmMenuItem(
             discounts
            ,false
            ,this.EnableRatesLabel
            ,this.GoToEnable
            ,'thumbs-up'
            ,'tb-icon-ok'
        ));

        discounts.AddItem(new dmMenuItem(
             discounts
            ,false
            ,this.MemberDiscountsLabel
            ,this.GoToDiscounts
            ,'trending-down'
            ,'tb-icon-primary'
        ));

        discounts.AddItem(new dmMenuItem(
             discounts
            ,false
            ,this.DiscountCalLabel
            ,this.GoToDiscountCal
            ,'calendar'
            ,'tb-icon-alert'
        ));

        discounts.AddItem(new dmMenuItem(
             discounts
            ,false
            ,this.EarlyBirdLabel
            ,this.GoToEarlyBird
            ,'logo-twitter'
            ,'tb-icon-primary'
        ));

        services.AddItem(new dmMenuItem(
             services
            ,false
            ,this.BookingsLabel
            ,this.GoToBookings
            ,'briefcase'
            ,'tb-icon-warn'
        ));

        services.AddItem(new dmMenuItem(
             services
            ,false
            ,this.PaymentLabel
            ,this.GoToPayment
            ,'card'
            ,'tb-icon-alert'
        ));

        services.AddItem(new dmMenuItem(
             services
            ,true
            ,this.PMSLabel
            ,this.GoToPMS
            ,'alert'
            ,'tb-icon-primary'
        ));

        propertyInfo.AddItem(new dmMenuItem(
             propertyInfo
            ,false
            ,this.DescriptionsLabel
            ,this.GoToDescriptions
            ,'document'
            ,'tb-icon-alert'
        ));

        propertyInfo.AddItem(new dmMenuItem(
             propertyInfo
            ,false
            ,this.PhotosLabel
            ,this.GoToPhotos
            ,'camera'
            ,'tb-icon-primary'
        ));

        propertyInfo.AddItem(new dmMenuItem(
            propertyInfo
            , false
            , this.DocsLabel
            , this.GoToDocs
            , 'document'
            , 'tb-icon-alert'
        ));


        propertyInfo.AddItem(new dmMenuItem(
             propertyInfo
            ,false
            ,this.MapsLabel
            ,this.GoToMaps
            ,'globe'
            ,'tb-icon-alert'
        ));

        propertyInfo.AddItem(new dmMenuItem(
             propertyInfo
            ,false
            ,this.FacilitiesLabel
            ,this.GoToFacilities
            ,'restaurant'
            ,'tb-icon-ok'
        ));

        propertyInfo.AddItem(new dmMenuItem(
             propertyInfo
            ,false
            ,this.CancellationLabel
            ,this.GoToCancellation
            ,'thumbs-down'
            ,'tb-icon-warn'
        ));
        
        propertyInfo.AddItem(new dmMenuItem(
             propertyInfo
            ,false
            ,this.PoliciesLabel
            ,() => { }
            ,'clipboard'
            ,'tb-icon-ok'
            ,() => { return this.Hotel.GetPoliciesURI(); }
        ));

        propertyInfo.AddItem(new dmMenuItem(
             propertyInfo
            ,false
            ,this.PreviewHPageLabel
            ,() => { }
            ,'list-box'
            ,'tb-icon-primary'
            ,() => { return this.Hotel.GetHotelPageURI(); }
        ));

        this.Menu.ConsolidateSlots();
        this.Menu.SetNearbyDisplay(this.Hotel.IsViaNearby);
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => {
            if (this.Hotel.IsAutoLogin) {
                window.location.href = 'https://www.tobook.com/HotelArea/index.html';
            }

            this.BackToSignIn();
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/xv-menu.ts